import { useEffect, useState } from "react";

import { Alert, Box, Chip, Paper, Stack, Typography } from "@mui/material";

import { API_URL } from "../config/api";
import VersionHistory from "../components/VersionHistory";

type AdminStatus = {
  clubConfigured: boolean;
  jayConfigured: boolean;
  persistentSessions: boolean;
  licenceListing?: {
    loaded: boolean;
    file?: string;
    count?: number;
    fileDate?: string;
  };
};

function StatusLine({ label, ok }: { label: string; ok: boolean }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Chip
        size="small"
        color={ok ? "success" : "error"}
        label={ok ? "OK" : "Non"}
      />
      <Typography>{label}</Typography>
    </Stack>
  );
}

// Page publique de diagnostic : aucune donnée sensible, seulement les
// versions et l'état de configuration des accès.
export default function VersionsPage() {
  const [status, setStatus] = useState<AdminStatus | null>(null);
  const [statusError, setStatusError] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/admin/status`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then(setStatus)
      .catch(() => setStatusError(true));
  }, []);

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", px: 3, py: 4 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        État du site
      </Typography>

      <Paper sx={{ p: 2, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Accès aux pages de suivi
        </Typography>

        {statusError && (
          <Alert severity="warning">
            État indisponible : le service tourne avec une version
            antérieure à la v1.1.4.
          </Alert>
        )}

        {status && (
          <Stack spacing={1}>
            <StatusLine
              ok={status.clubConfigured}
              label="Mot de passe club (/alain) configuré sur le serveur"
            />
            <StatusLine
              ok={status.jayConfigured}
              label="Mot de passe Jay (/jay) configuré sur le serveur"
            />
            <StatusLine
              ok={status.persistentSessions}
              label="Connexions conservées après un redémarrage du service"
            />
            <StatusLine
              ok={!!status.licenceListing?.loaded}
              label={
                status.licenceListing?.loaded
                  ? `Listing des licences chargé : ${status.licenceListing.file} (${status.licenceListing.count} licences, déposé le ${new Date(
                      status.licenceListing.fileDate ?? ""
                    ).toLocaleDateString("fr-BE")})`
                  : "Listing des licences (Back/private/*.xlsx) non chargé"
              }
            />
          </Stack>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Après une modification de Back/.env, le service doit être
          redémarré pour en tenir compte.
        </Typography>
      </Paper>

      <VersionHistory />
    </Box>
  );
}
